import React, { Component } from 'react'
import log from 'lib/log'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage } from 'react-intl'
import { clearDraft, prepareDraft, loadUnpublishedDraft } from 'actions/drafts'
import { loadResponses } from 'actions/responses'
import { getPersonName } from 'components/PersonName'
import Avatar from 'components/Avatar'
import styles from './Respond.css'

// ensure the composer isn't loaded until we need it by loading via universal!
import universal from 'react-universal-component'
const InlineArticleComposer = universal(props =>
  import('post-responses/InlineArticleComposer')
)

class Respond extends Component {
  constructor(props) {
    super(props)
    this.state = {
      responding: false
    }
    this.handleClickToRespond = this.handleClickToRespond.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.handlePublish = this.handlePublish.bind(this)
  }
  async componentDidMount() {
    try {
      const { to, loadUnpublishedResponse, clearDraft } = this.props
      clearDraft()
      const draft = await loadUnpublishedResponse({
        responseTo: to._id
      })
    } catch (draftErr) {
      // there probably isn't an unpublished response, but
      // in any case we wouldn't handle the error here, we'd
      // wait for the redux state to propagate
      //log.info(draftErr)
    }
  }
  shouldComponentUpdate(newProps, newState) {
    let { responding: oldResponding } = this.state
    if (oldResponding) {
      let { responding: newResponding } = newState
      // if we are already cooking a response, the only things
      // that should trigger a re-render are discarding or publishing,
      // otherwise we get nasty effects like the cursor jumping to
      // the start of the response text every time auto-save triggers
      return !newResponding
    } else {
      return true
    }
  }
  componentWillReceiveProps(newProps) {
    if (
      !this.props.draft &&
      newProps.draft &&
      newProps.draft.responseTo === this.props.to._id
    ) {
      if (!this.state.responding) {
        setTimeout(() => {
          this.setState({ responding: true })
        }, 100)
      }
    } else {
      if (
        this.state.responding &&
        newProps.draft &&
        newProps.draft.responseTo !== this.props.to._id
      ) {
        this.setState({ responding: false })
      }
    }
  }
  handleClickToRespond(ev) {
    this.props.prepareDraft({
      responseTo: this.props.to._id
    })
    this.setState({ responding: true })
  }
  handleDiscard() {
    this.setState({ responding: false })
  }
  async handlePublish() {
    this.setState({ responding: false })
    const { loadResponses, to } = this.props
    try {
      await loadResponses({ _id: to._id })
      // todo: scroll to show the response?
    } catch (e) {
      // todo
    }
  }
  render() {
    const { profile: { avatar } = {}, to } = this.props
    if (this.state.responding) {
      return (
        <InlineArticleComposer
          to={to}
          onDiscard={this.handleDiscard}
          onPublish={this.handlePublish}
        />
      )
    } else {
      return (
        <div className={styles.respond} onClick={this.handleClickToRespond} data-intro="respond">
          <Avatar avatar={avatar} />
          <span className={styles.response}>
              <FormattedMessage
                id={to?.type === "discussion" ? "post.respond_discussion" : "post.respond"}
                values={{ name: to ? getPersonName(to.author) : '' }}
              />
          </span>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ draft: { value: draft } }) => ({ draft })
const mapDispatchToProps = dispatch => ({
  clearDraft: bindActionCreators(clearDraft, dispatch),
  prepareDraft: bindActionCreators(prepareDraft, dispatch),
  loadResponses: bindActionCreators(loadResponses, dispatch),
  loadUnpublishedResponse: bindActionCreators(loadUnpublishedDraft, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Respond)
